import { render, staticRenderFns } from "./FeedPostReactions.vue?vue&type=template&id=43961bce&scoped=true&lang=pug&"
import script from "./FeedPostReactions.vue?vue&type=script&lang=js&"
export * from "./FeedPostReactions.vue?vue&type=script&lang=js&"
import style0 from "./FeedPostReactions.vue?vue&type=style&index=0&id=43961bce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43961bce",
  null
  
)

export default component.exports